import {
  needsSharedVehicleDerivedFieldRepair,
  resolveSharedHomeVehicleDerivedFields,
  type SharedHomeVehicleRecord,
} from '../../ui-foundation';
import { supabase } from '@/integrations/supabase/client';
import { invokeDvlaVehicleLookup } from './dvla';

function vehicleRepairPayload(vehicle: SharedHomeVehicleRecord) {
  return {
    registration_number: vehicle.registrationNumber,
    make: vehicle.make,
    mot_due_date: vehicle.motDueDate,
    mot_status: vehicle.motStatus,
    tax_due_date: vehicle.taxDueDate,
    tax_status: vehicle.taxStatus,
    tax_annual_cost: vehicle.taxAnnualCost,
    tax_six_month_cost: vehicle.taxSixMonthCost,
    tax_monthly_direct_debit_total: vehicle.taxMonthlyDirectDebitTotal,
    tax_monthly_direct_debit_installment: vehicle.taxMonthlyDirectDebitInstallment,
    mot_estimated_cost: vehicle.motEstimatedCost,
    service_last_date: vehicle.serviceLastDate,
    service_due_date: vehicle.serviceDueDate,
    dvla_synced_at: vehicle.dvlaSyncedAt,
  };
}

function didVehicleRepairChange(
  current: SharedHomeVehicleRecord,
  next: SharedHomeVehicleRecord,
) {
  return JSON.stringify(vehicleRepairPayload(current)) !== JSON.stringify(vehicleRepairPayload(next));
}

export async function repairStoredHomeVehicle(
  vehicle: SharedHomeVehicleRecord,
): Promise<SharedHomeVehicleRecord> {
  if (!needsSharedVehicleDerivedFieldRepair(vehicle)) {
    return vehicle;
  }

  let lookup = null;
  if (vehicle.registrationNumber) {
    const { data } = await invokeDvlaVehicleLookup(vehicle.registrationNumber);
    lookup = data;
  }

  const repairedVehicle = resolveSharedHomeVehicleDerivedFields(vehicle, lookup);

  if (vehicle.id && didVehicleRepairChange(vehicle, repairedVehicle)) {
    await (supabase as any)
      .from('home_vehicles')
      .update(vehicleRepairPayload(repairedVehicle))
      .eq('id', vehicle.id);
  }

  return repairedVehicle;
}
